var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({ref:"img",attrs:{"src":_vm.initialSrc}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }